export default __webpack_public_path__ + "static/media/detail_small_1_4.1a353100.png";